import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible";
import "./utils/vant";
//全局mixin
import "./utils/mixin";
import "./assets/common.less";
import "./utils/directives";
import VConsole from "vconsole";
import "vant/lib/index.less";
import "./utils/filter";
import smoothscroll from "smoothscroll-polyfill";
import "./utils/eventBus";
// 引入i18n实例
import i18n from "./i18n";
import { showLoading, hideLoading } from "@/utils/loading";
import "./permission";
// 引入 WASM 初始化模块
import { initWasm } from "./utils/wasm";

smoothscroll.polyfill();

if (process.env.NODE_ENV !== "production") {
  new VConsole();
}
import NavBar from "@/components/NavBar";
import SendMsg from "@/components/SendMsg";
import VerifiedModal from "@/components/VerifiedModal";

import im from "@/views/im";
Vue.component("NavBar", NavBar);
Vue.component("SendMsg", SendMsg);
Vue.component("VerifiedModal", VerifiedModal);

Vue.prototype.showLoading = showLoading;
Vue.prototype.hideLoading = hideLoading;

Vue.config.productionTip = false;

// 初始化 WASM 模块（等待初始化完成后再启动应用）
initWasm()
  .then(() => {
    console.log("WASM initialized successfully");
  })
  .catch((error) => {
    console.warn("WASM initialization failed:", error);
    // 应用可以继续运行，但不会有签名功能
  })
  .finally(() => {
    // WASM初始化完成（成功或失败）后，启动Vue应用
    new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App),
    }).$mount("#app");
  });
